<template>
  <div>
    <a-card>
      <div slot="title">
        {{ this.id ? 'Edit' : 'Create' }} Expenditure Plan
      </div>
      <a-form-model
        ref="ruleForm"
        :model="form.model"
        :rules="form.rules"
      >
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-model-item label="Budget Type" prop="budget_type">
              <a-select
                showSearch
                v-model="form.model.budget_type"
                :disabled="loading.table.left"
                @change="(e)=>{handleJenisAnggaran(e);onchangedHeader('budget_type');}"
              >
                <a-select-option v-for="item in getJenisAnggaran" :key="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-model-item label="Cost Center" prop="cost_center">
              <a-select
                showSearch
                v-model="form.model.cost_center"
                :disabled="loading.table.left"
                @change="(e)=>{handle_Cost(e);onchangedHeader('cost_center');}"
              >
                <a-select-option v-for="item in costCenter" :key="item.value">
                  {{ item.text }} ({{
                    item.nama_pekerjaan ? item.nama_pekerjaan : "-"
                  }})
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-model-item label="Plafon Period" prop="period">
              <a-select showSearch v-model="form.model.period" :disabled="disabled.header">
                <a-select-option v-for="item in list_periode" :key="item.key" @change="onchangedHeader('period')">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-slider v-if="!getScreen" id="positionCol" class="slider-cep" v-model="positionCol" :tooltipVisible="false" :min="0" :max="24"/>
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: positionCol }">
            <a-table
              :columns="columns.left"
              :dataSource="datasource.left"
              id="id_table_left"
              size="small" 
              :pagination="false"
              :loading="loading.table.left"
              :scroll="{ x: 800, y: '100vh' }"
              :expanded-row-keys.sync="expandedKeys"
              :rowClassName="getRowClassName"
              bordered
            >
              <template slot="aksi" slot-scope="item">
                <a-button v-if="!item.children && item.saldo>0" size="small" icon="plus" type="primary" @click="handleAdd(item)"></a-button>
              </template>
              <template slot="budget" slot-scope="item">
                {{ item.item }}
              </template>
              <template slot="budget_code" slot-scope="item">
                {{ item.kode_anggaran }}
              </template>
              <template slot="balance" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.saldo?item.saldo:0"
                />
              </template>
            </a-table>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 24-positionCol }">
            <a-table
              :columns="columns.right"
              :dataSource="datasource.right"
              :rowKey="(record, index) => { return index; }"
              id="id_table_right"
              size="small"
              :pagination="false"
              :loading="loading.table.right"
              :scroll="{ x: 1000, y: '100vh' }"
              bordered
            >
              <template slot="no" slot-scope="text,item,index">
                {{ index+1 }}
              </template>
              <template slot="cost_center" slot-scope="item">
                {{ item.cost_center_kode }}
              </template>
              <template slot="code_budget" slot-scope="item">
                <div>{{ item.kode_anggaran }}</div>
                <div>{{ item.item_anggaran }}</div>
              </template>
              <template slot="description" slot-scope="item">
                {{ item.deskripsi }}
              </template>
              <template slot="nilai" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.nilai_rencana"
                />
              </template>
              <template slot="aksi" slot-scope="item">
                <a-button size="small" icon="close" type="danger" 
                  :loading="loading.table.key_right==item.rencana_belanja_dtl_id"
                  @click="handleDelete(item)">
                </a-button>
              </template>
            </a-table>
          </a-col>
        </a-row>
      </a-form-model>
      <div slot="actions" class="m-display-flex space-between">
        <div></div>
        <div>
          <a-button-group>
            <a-button v-if="!this.$route.name.includes('expenditurePlanRevise')" :disabled="loading.submit" @click="saveTrans('draft')">
              <span>Save Draft</span>
            </a-button>
            <a-button type="primary" :loading="loading.submit" @click="saveTrans('submit')">
              <span>Submit</span>
            </a-button>
          </a-button-group>
        </div>
      </div>
    </a-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import lodash from 'lodash';
import deepdash from 'deepdash';
const _ = deepdash(lodash);
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "expanditurePlanCreate",
  mixins: [GlobalMethod, CurrencyFormat],
  components: {},
  props:["id"],
  data() {
    return {
      form:{
        model:{
          period: null,
          budget_type: null,
          cost_center: null
        },
        rules:{
          period: {
            required: true,
            message: "Plafon Periode is required!",
            trigger: "change",
          },
          budget_type: {
            required: true,
            message: "Budget Type is required!",
            trigger: "change",
          },
          cost_center: {
            required: true,
            message: "Cost Center is required!",
            trigger: "change",
          },
        }
      },
      costCenter: [],
      datasource:{
        left: [],
        right: []
      },
      pagination:{
        right: {
          page: 1,
          onChange: (page) => {
            this.pagination.right.page = page;
          },
          pageSize: 10,
          size: "small",
        }
      },
      loading:{
        table: {
          left: false,
          right: false,
          key_right: ''
        },
        submit: false
      },
      disabled:{
        header: false
      },
      expandedKeys: [],
      positionCol: 12,
      addModal:{
        desc: null,
        nilai: null,
        max_nilai: null,
      },
      id_newtrans:null,
      base_data_periode: []
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeStandartFormat",
      "getJenisAnggaran",
      "getCostCenter",
    ]),
    list_periode(){
      return this.id && this.form.model.period ? 
      [
        {
          key: moment(this.form.model.period).format("YYYY-MM"),
          label: moment(this.form.model.period).locale("id").format('MMMM-YYYY')
        },
      ]
      : this.getPeriodeList()
    },
    columns(){
      return {
        left: [
          {
            title: "Budgeting",
            scopedSlots: { customRender: "budget" },
          },
          {
            title: "Period",
            scopedSlots: { customRender: "period" },
            children: [
              {
                title: "Code Budget",
                width: '200px',
                scopedSlots: { customRender: "budget_code" },
              },
              {
                title: "Balance",
                width: '150px',
                scopedSlots: { customRender: "balance" },
              },
            ]
          },
          {
            title: "#",
            width: '50px',
            align: "center",
            fixed: "right",
            scopedSlots: { customRender: "aksi" },
          },
        ],
        right: [
          {
            title: "#",
            width: '50px',
            scopedSlots: { customRender: "no" },
          },
          {
            title: "Cost Center",
            width: '150px',
            scopedSlots: { customRender: "cost_center" },
          },
          {
            title: "Code | Item Budget",
            width: '250px',
            scopedSlots: { customRender: "code_budget" },
          },
          {
            title: "Description",
            scopedSlots: { customRender: "description" },
          },
          {
            title: "Value",
            width: '150px',
            scopedSlots: { customRender: "nilai" },
          },
          {
            title: "#",
            width: '50px',
            fixed: "right",
            scopedSlots: { customRender: "aksi" },
          },
        ]
      }
    }
  },
  mounted() {
    this.$store.dispatch("FETCH_COST_CENTER");
    if(this.id){
      this.id_newtrans = this.id
      this.disabled.header = true

      this.loading.table.left = true
      this.loading.table.right = true
      this.asyncAxiosGet(this.$route.name.includes('expenditurePlanRevise') ? "Rencana_belanja/tambah" : "Rencana_belanja/draft",
        this.getAuth,
        {
          rencana_belanja_id: this.id_newtrans,
        }
      ).then(async (response) => {
        this.form.model.period = this.$route.name.includes('expenditurePlanRevise') ? moment(response.hdr[0].periode_plafon).format("YYYY-MM") : 
          moment(response.periode).format("YYYY-MM")
        this.form.model.budget_type = null
        this.form.model.cost_center = null

        this.datasource.right = response.dtl

        this.loading.table.left = false
        this.loading.table.right = false
      }).catch(() => {
        this.loading.table.left = false
        this.loading.table.right = false
      });
    }else{
      this.getAvailabelPeriode();
    }
  },
  methods: {
    moment,
    onchangedHeader(type){
      this.datasource.left = []
      if(this.id_newtrans==null){
        this.disabled.header = false
      }

      if(type=='period'){
        this.form.model.budget_type = null,
        this.form.model.cost_center = null
      }else if(type=="budget_type"){
        this.form.model.cost_center = null
      }
    },
    handleJenisAnggaran(e) {
      this.form.model.cost_center = null;
      const filter = this.getCostCenter.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.costCenter = filter;
    },
    async handle_Cost(e){
      this.loading.table.left = true
      this.loading.table.right = true
      this.disabled.header = true
      await this.asyncAxiosGet("Rencana_belanja/budget",
        this.getAuth,
        {
          anggaran_id: e,
          rencana_belanja_id: this.id_newtrans
        }
      ).then((res) => {
        this.datasource.left = [{...res.budget}];
        this.expandAll()

        this.loading.table.left = false
        this.loading.table.right = false

        if(this.datasource.right.length==0){
          this.disabled.header = false
        }
      }).catch(() => {
        this.loading.table.left = false
        this.loading.table.right = false
      });
    },
    getAllKeys(data) {
      let keys = [];
      data.forEach(item => {
        keys.push(item.key);
        if (item.children && item.children.length > 0) {
          keys = keys.concat(this.getAllKeys(item.children));
        }
      });
      return keys;
    },
    expandAll() {
      this.expandedKeys = this.getAllKeys(this.datasource.left);
    },
    validateMaxValue(e, maxValue){      
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];
      if (allowedKeys.includes(e.key)) return;

      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
        return;
      }

      const currentRawValue = e.target.value.replace(/,/g, '');
      const predictedValue = Number(currentRawValue + e.key);

      if (predictedValue > maxValue) {
        e.preventDefault();
      }
    },
    handleAdd(item){
      if(!this.form.model.period){
        this.displayMessageValue("error-other", 'Plafon Period is Required!');
        return;
      }
      const that = this;
      that.addModal.desc = ''
      that.addModal.nilai = item.saldo
      that.addModal.max_nilai = item.saldo

      this.$confirm({
        title: false,
        content: (h) => {
          return h('div', { style: {} }, [
            h('div', { style: {} }, [
              h('label', { style: {fontWeight: 'bold'} }, 'Kode Budget : '+ item.kode_anggaran),
            ]),
            h('div', { style: { marginTop: '10px' } }, [
              h('label', { style: {fontWeight: 'bold'} }, 'Item Name   : '+ item.item),
            ]),
            h('div', { style: { marginTop: '10px' } }, [
              h('label', { style: {} }, 'Expenditure Plan Description'),
              h('a-textarea', {
                props: {
                  autoFocus: true,
                  required: true,
                  value: that.addModal.desc
                },
                attrs: {
                  maxLength: 255,
                  placeholder: 'Type here...'
                },
                on: {
                  blur: (val) => {
                    that.addModal.desc = val.target.value;
                  },
                }
              })
            ]),
            h('div', { style: { marginTop: '10px' } }, [
              h('label', { style: {} }, 'Expenditure Plan Value'),
              h('a-input-number', {
                props: {
                  value: that.addModal.nilai,
                  required: true,
                  formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                  parser: (value) => value.replace(/(,*)/g, ''), 
                  min: 1,
                  max: that.addModal.max_nilai,
                },
                on: {
                  change: (val) => {
                    that.addModal.nilai = val;
                  },
                  keydown: (e) => {
                    that.onlyNumber(e);
                    that.validateMaxValue(e, that.addModal.max_nilai);
                  }
                },
                class: 'width-full m-text-align-right'
              })
            ]),
          ],);
        },
        okText: "Yes",
        cancelText: "No",
        onOk() {

          if(that.addModal.desc == null || that.addModal.desc == ''){
            that.displayMessageValue("error-other", "Expenditure Plan Description is Required!");
            return Promise.reject();
          }

          let tempTotal = _.sumBy(that.datasource.right, function (val) {
            return (val.anggaran_dtl_val_id == item.id?  Number(val.nilai_rencana) : 0)
          });

          if((tempTotal+that.addModal.nilai)>that.addModal.max_nilai){
            that.displayMessageValue("error-other", "The Expenditure Plan has been exceeded ("+
              that.formatRupiah((tempTotal+that.addModal.nilai))
              +" > "+
              that.formatRupiah(that.addModal.max_nilai)
              +")!");
            return Promise.reject();
          }

          that.loading.table.left = true
          that.loading.table.right = true
          that.asyncAxiosPost(that.id_newtrans ? "Rencana_belanja/tambah" : "Rencana_belanja", "json", that.getAuth, {
            periode: that.form.model.period,
            anggaran_dtl_val_id: item.id,
            cost_center: that.form.model.cost_center,
            deskripsi: that.addModal.desc,
            nilai_rencana: that.addModal.nilai,
            rencana_belanja_id: that.id_newtrans

          })
          .then((response) =>{
            if(that.datasource.right.length==0 && response.rencana_belanja_id){
              that.displayMessageValue("success-other", response.message);
                that.disabled.header = true
                that.loading.table.left = false
                that.loading.table.right = false
                that.id_newtrans = response.rencana_belanja_id
                that.datasource.right = response.dtl

                that.$router.push({
                  name: (that.$route.name=='expenditurePlanCreateAL' ? "expenditurePlanEditAL" : "expenditurePlanEditPimpro"),
                  params: { id: response.rencana_belanja_id}
                });
            }else{
              that.disabled.header = true
              that.id_newtrans = response.rencana_belanja_id
              that.datasource.right = response.dtl

              // that.updateDataTree(that.datasource.left, 'anggaran_dtl_val_id', item.id, 'hidden', true);

              that.loading.table.left = false
              that.loading.table.right = false

              that.displayMessageValue("success-other", response.message);
            }
          })
          .catch((err) => {
            console.log(err);
            that.loading.table.left = false
            that.loading.table.right = false
          });
        },
        onCancel() {
        }
      })
    },
    handleDelete(item){
      const that = this

      this.$confirm({
        title: "Are you sure to delete?",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading.table.key_right = item.rencana_belanja_dtl_id

          that.asyncAxiosDelete(
            that.$route.meta.revise ? "Rencana_belanja/hapus" : "Rencana_belanja",
            "application/json",
            that.getAuth,
            { rencana_belanja_dtl_id: item.rencana_belanja_dtl_id }
          )
          .then((response) => {
            that.loading.table.key_right = ''

            that.datasource.right = response.dtl
            // that.updateDataTree(that.datasource.left, 'anggaran_dtl_val_id', item.anggaran_dtl_val_id, 'hidden', false);

            if (response.status && response.status == true) {
              that.displayMessageValue("success-other", response.message);
            } else {
              let responses = Object.assign({}, response);
              that.displayMessageValue("error-other", responses);
            }
          })
          .catch(() => {
            that.loading.table.key_right = ''
          });
        },
        onCancel() {
        }
      });
    },
    updateDataTree(data, keyLabel, keyId, newLabel, newValue) {
      _.each(data, (node) => {
        if (node[keyLabel] === keyId) {
          node[newLabel] = newValue; 
        }
        if (node.children && !_.isEmpty(node.children)) {
          this.updateDataTree(node.children, keyLabel, keyId, newLabel, newValue);
        }
      });
    },
    getRowClassName(record){
      return ''
      // return record && record.hidden ? 'hidden-row-budget' : '';
    },
    saveTrans(type){
      const that = this
      if(type=='draft'){
        that.displayMessageValue("success-other", 'Save as Draft is successfully!');
        setTimeout(
          function () {
            that.$router.push({
              name: (that.$route.name=='expenditurePlanCreateAL' ? "expenditurePlanAL" : "expenditurePlanPimpro"),
              params: {},
              query:{
                default_tab_draft: true
              }
            });
          },
          1000
        ) ;
      }else if(type=='submit'){
        if(this.$route.name.includes('expenditurePlanRevise')){
          that.loading.submit = true
          that.displayMessageValue("success-other", "Success edit manifest");
          setTimeout(
                function () {
                  that.$router.push({
                    name: (that.$route.name=='expenditurePlanCreateAL' ? "expenditurePlanManifestAL" : "expenditurePlanManifestPimpro"),
                    params: { id: that.id},
                  });
                },
                1000
              ) ;
        }else{
          that.asyncAxiosPost("Rencana_belanja/draft", "json", that.getAuth, {
              rencana_belanja_id: that.id_newtrans
            })
            .then((response) =>{
              that.loading.submit = true
              that.displayMessageValue("success-other", response.message);
              setTimeout(
                function () {
                  that.$router.push({
                    name: (that.$route.name=='expenditurePlanCreateAL' ? "expenditurePlanManifestAL" : "expenditurePlanManifestPimpro"),
                    params: { id: response.rencana_belanja_id},
                  });
                },
                1000
              ) ;
            })
            .catch((err) => {
              console.log(err);
              that.loading.table.left = false
              that.loading.table.right = false
            });
        }
      }
    },
    async getAvailabelPeriode(){
      await this.asyncAxiosGet("rencana_belanja/periode",
          this.getAuth, {}
      ).then((response) => {
        this.base_data_periode = response.periode
      })
      .catch(()=>{

      })
    },
    getPeriodeList(){
      let temp = []
      this.base_data_periode.forEach(element => {
        temp.push({
          key: moment(element.periode).format("YYYY-MM"),
          label: moment(element.periode).locale("id").format('MMMM-YYYY')
        })
      });
      return temp
    }
  }
};
</script>

<style lang="less">
.slider-cep{
  margin: 0px 0px 5px 0px!important;
  .ant-slider-track{
    background-color: #8de3c900!important;
  }
}

.ant-table-tbody{
  .hidden-row-budget{
    // display: none!important;
  }
}
</style>
